/* SPORT.FR — Product Page JS v12
   Fix : updateOptionAvailability() appele immediatement au clic swatch,
   meme si la combinaison (couleur + taille actuelle) n'existe pas.
   Ainsi les tailles se barrent des la selection de la couleur.
*/
'use strict';

function fmtMoney(c){return(c/100).toLocaleString('fr-FR',{style:'currency',currency:'EUR'});}
function pad(n){return String(n).padStart(2,'0');}
function frDate(d){var mo=['jan.','fév.','mars','avr.','mai','juin','juil.','août','sept.','oct.','nov.','déc.'];return d.getDate()+' '+mo[d.getMonth()];}
function addDays(d,n){var r=new Date(d);r.setDate(r.getDate()+n);return r;}

var Gallery=(function(){
  var mainImg,thumbsWrap,prevBtn,nextBtn;
  var allThumbs=[];var curIdx=0;
  var carousel=null,dotsWrap=null,mobileThumbs=[],ioObserver=null;
  var allImages=[],visibleImages=[],imageMap={},variantImageIdSet={};

  function init(){
    mainImg=document.getElementById('gallery-main-img');
    thumbsWrap=document.getElementById('gallery-thumbs');
    prevBtn=document.getElementById('gallery-prev');
    nextBtn=document.getElementById('gallery-next');
    _buildList();
    if(prevBtn) prevBtn.addEventListener('click',function(){goTo(curIdx-1);});
    if(nextBtn) nextBtn.addEventListener('click',function(){goTo(curIdx+1);});
    carousel=document.querySelector('.gm-carousel');
    dotsWrap=document.querySelector('.gm-dots');
    mobileThumbs=Array.from(document.querySelectorAll('.gm-thumb'));
    Array.from(document.querySelectorAll('.gm-slide')).forEach(function(s){
      var img=s.querySelector('img');
      allImages.push({id:String(s.dataset.imageId),src:img?img.src:'',alt:img?(img.alt||''):'',isVariant:s.dataset.isVariant==='true'});
    });
    visibleImages=allImages.slice();
    mobileThumbs.forEach(function(t){
      t.addEventListener('click',function(){
        var imgId=String(t.dataset.imageId);
        var idx=visibleImages.findIndex(function(im){return im.id===imgId;});
        if(idx!==-1){_scrollToIdx(idx);}else{var d=imageMap[imgId];if(d)_insertVariantSlideFirst(imgId,d.src,d.alt);}
      });
    });
    _initObserver();
  }

  function setImageMap(map){
    Object.keys(map).forEach(function(k){imageMap[String(k)]=map[k];if(map[k].isVariant)variantImageIdSet[String(k)]=true;});
    allImages.forEach(function(im){var d=imageMap[im.id];if(d){im.src=d.src;im.alt=d.alt||im.alt;}});
    if(carousel){Array.from(carousel.querySelectorAll('.gm-slide')).forEach(function(s){var d=imageMap[String(s.dataset.imageId)];if(d){var img=s.querySelector('img');if(img)img.src=d.src;}});}
  }

  function _initObserver(){
    if(ioObserver){ioObserver.disconnect();ioObserver=null;}
    if(!carousel||!('IntersectionObserver' in window))return;
    var slides=Array.from(carousel.querySelectorAll('.gm-slide'));
    if(!slides.length)return;
    ioObserver=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(!entry.isIntersecting)return;
        var idx=slides.indexOf(entry.target);if(idx===-1)return;
        _setMobileActive(idx);
      });
    },{root:carousel,threshold:0.5});
    slides.forEach(function(s){ioObserver.observe(s);});
  }

  function _scrollToIdx(idx){if(!carousel)return;carousel.scrollTo({left:carousel.clientWidth*idx,behavior:'smooth'});}

  function _setMobileActive(idx){
    var dots=dotsWrap?Array.from(dotsWrap.querySelectorAll('.gm-dot')): [];
    dots.forEach(function(d,i){d.classList.toggle('gm-dot--active',i===idx);});
    var imgId=visibleImages[idx]?visibleImages[idx].id:null;
    mobileThumbs.forEach(function(t){
      var match=(String(t.dataset.imageId)===imgId&&t.style.display!=='none');
      t.classList.toggle('gm-thumb--active',match);
      if(match)t.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});
    });
  }

  function _rebuildCarousel(images){
    if(!carousel)return;
    visibleImages=images;
    Array.from(carousel.querySelectorAll('.gm-slide')).forEach(function(s){s.remove();});
    images.forEach(function(im,i){
      var div=document.createElement('div');
      div.className='gm-slide';div.dataset.imageId=im.id;div.dataset.isVariant=im.isVariant?'true':'false';
      var img=document.createElement('img');
      var d=imageMap[im.id];img.src=d?d.src:im.src;img.alt=(d?d.alt:im.alt)||'';img.loading=i===0?'eager':'lazy';
      div.appendChild(img);carousel.appendChild(div);
    });
    if(dotsWrap){
      dotsWrap.innerHTML='';
      if(images.length>1){images.forEach(function(_,i){var dot=document.createElement('span');dot.className='gm-dot'+(i===0?' gm-dot--active':'');dotsWrap.appendChild(dot);});}
    }
    carousel.scrollLeft=0;
    _initObserver();
  }

  function _insertVariantSlideFirst(sid,src,alt){
    var nonVariant=allImages.filter(function(im){return !im.isVariant;});
    var varImg={id:sid,src:src,alt:alt||'',isVariant:true};
    var newList=[varImg].concat(nonVariant);
    var existingIdx=allImages.findIndex(function(im){return im.id===sid;});
    if(existingIdx===-1)allImages.unshift(varImg);else allImages[existingIdx]=varImg;
    _rebuildCarousel(newList);
  }

  function _buildList(){
    if(!thumbsWrap)return;
    allThumbs=Array.from(thumbsWrap.querySelectorAll('.gallery-thumb')).filter(function(el){return el.style.display!=='none';});
    allThumbs.forEach(function(t,i){t.onclick=function(){goTo(i);};});
    curIdx=0;
    allThumbs.forEach(function(t,i){if(t.classList.contains('gallery-thumb--active'))curIdx=i;});
    _arrows();
  }
  function goTo(idx){
    if(!allThumbs.length)return;
    idx=Math.max(0,Math.min(idx,allThumbs.length-1));curIdx=idx;
    var t=allThumbs[idx];if(!t)return;
    if(mainImg){mainImg.style.opacity='0.3';mainImg.src=t.dataset.src;mainImg.alt=t.dataset.alt||'';mainImg.onload=function(){mainImg.style.opacity='1';};}
    allThumbs.forEach(function(x){x.classList.remove('gallery-thumb--active');});t.classList.add('gallery-thumb--active');
    _arrows();
  }
  function _arrows(){
    if(prevBtn)prevBtn.classList.toggle('gallery-arrow--hidden',curIdx===0);
    if(nextBtn)nextBtn.classList.toggle('gallery-arrow--hidden',curIdx>=allThumbs.length-1);
  }
  function _setMainDesktop(src,alt){
    if(!mainImg||!src)return;
    mainImg.style.opacity='0.3';mainImg.src=src;mainImg.alt=alt||'';
    mainImg.onload=function(){mainImg.style.opacity='1';};
  }

  function setVariantImage(imgId,imgSrc,imgAlt){
    var sid=String(imgId);
    if(thumbsWrap){
      var vt=thumbsWrap.querySelectorAll('.gallery-thumb[data-is-variant="true"]');
      if(vt.length){
        vt.forEach(function(t){t.style.display=(String(t.dataset.imageId)===sid)?'':'none';});
        _buildList();
        var ti=0;allThumbs.forEach(function(t,i){if(String(t.dataset.imageId)===sid)ti=i;});goTo(ti);
      }else{_setMainDesktop(imgSrc,imgAlt);}
    }else{_setMainDesktop(imgSrc,imgAlt);}
    var hasVariantInCarousel=allImages.some(function(im){return im.isVariant;});
    if(!hasVariantInCarousel&&variantImageIdSet[sid]){
      _insertVariantSlideFirst(sid,imgSrc,imgAlt);
    }else{
      var filtered;
      if(!hasVariantInCarousel){filtered=allImages.slice();}
      else{
        filtered=allImages.filter(function(im){if(!im.isVariant)return true;return im.id===sid;});
        if(!filtered.some(function(im){return im.isVariant;})){filtered.unshift({id:sid,src:imgSrc,alt:imgAlt||'',isVariant:true});}
      }
      var varImg=filtered.find(function(im){return im.id===sid;});
      var rest=filtered.filter(function(im){return im.id!==sid;});
      filtered=varImg?[varImg].concat(rest):filtered;
      _rebuildCarousel(filtered);
    }
    mobileThumbs.forEach(function(t){
      if(t.dataset.isVariant==='true'){
        var show=String(t.dataset.imageId)===sid;
        t.style.display=show?'':'none';t.classList.toggle('gm-thumb--active',show);
      }else{t.style.display='';t.classList.remove('gm-thumb--active');}
    });
  }

  return{init:init,setImageMap:setImageMap,setVariantImage:setVariantImage};
})();

var imageMapById={};

document.addEventListener('DOMContentLoaded',function(){
  var imgJsonEl=document.getElementById('product-images-json');
  if(imgJsonEl){
    try{JSON.parse(imgJsonEl.textContent).forEach(function(img){imageMapById[String(img.id)]={src:img.src,alt:img.alt||'',isVariant:!!img.isVariant};});}
    catch(e){}
  }

  Gallery.init();
  Gallery.setImageMap(imageMapById);

  var variantsEl=document.getElementById('product-variants-json');
  var variants=variantsEl?JSON.parse(variantsEl.textContent):[];
  var selectedOptions={};
  var currentVariant=variants[0]||null;
  if(currentVariant)currentVariant.options.forEach(function(o,i){selectedOptions[i]=o;});

  function findVariant(opts){
    return variants.find(function(v){return v.options.every(function(o,i){return o===opts[i];});})||null;
  }

  /*
   * Met a jour la dispo des boutons d'option (tailles/litres) selon selectedOptions.
   * Appele immediatement au clic swatch ET dans applyVariant.
   * Fonctionne meme si aucune variante valide n'existe pour la combinaison courante.
   */
  function updateOptionAvailability(){
    document.querySelectorAll('.product-option__values').forEach(function(group){
      var optIdx=parseInt(group.dataset.optionIdx,10);
      if(isNaN(optIdx))return;
      group.querySelectorAll('.product-option__value').forEach(function(btn){
        var val=btn.dataset.value;
        var candidate={};
        Object.keys(selectedOptions).forEach(function(k){candidate[k]=selectedOptions[k];});
        candidate[optIdx]=val;
        var isAvailable=variants.some(function(v){
          return v.available&&v.options.every(function(o,i){return o===candidate[i];});
        });
        btn.classList.toggle('unavailable',!isAvailable);
      });
    });
  }

  function updateBundleCards(){
    document.querySelectorAll('.bundle-card').forEach(function(card){
      var idx=parseInt(card.dataset.optionIndex,10),val=card.dataset.value;
      var candidate={};
      Object.keys(selectedOptions).forEach(function(k){candidate[k]=selectedOptions[k];});
      candidate[idx]=val;
      var v=findVariant(Object.values(candidate));
      var priceEl=card.querySelector('[data-bundle-price]'),compareEl=card.querySelector('[data-bundle-compare]'),discountEl=card.querySelector('[data-bundle-discount]');
      if(v){
        if(priceEl)priceEl.textContent=fmtMoney(v.price);
        if(v.compare_at_price>v.price){
          if(priceEl)priceEl.classList.add('bundle-card__price--sale');
          if(compareEl){compareEl.textContent=fmtMoney(v.compare_at_price);compareEl.hidden=false;}
          if(discountEl){discountEl.textContent='-'+Math.round((v.compare_at_price-v.price)/v.compare_at_price*100)+'%';discountEl.hidden=false;}
        }else{
          if(priceEl)priceEl.classList.remove('bundle-card__price--sale');
          if(compareEl)compareEl.hidden=true;
          if(discountEl)discountEl.hidden=true;
        }
        if(v.available){card.classList.remove('bundle-card--unavailable');card.removeAttribute('aria-disabled');}
        else{card.classList.add('bundle-card--unavailable');card.setAttribute('aria-disabled','true');}
      }else{card.classList.add('bundle-card--unavailable');card.setAttribute('aria-disabled','true');}
      card.classList.toggle('bundle-card--active',String(selectedOptions[idx])===String(val));
    });
  }

  function applyVariant(v){
    if(!v)return;
    currentVariant=v;
    var priceEl=document.getElementById('product-price'),compareEl=document.getElementById('product-compare-price'),discountEl=document.getElementById('product-discount-badge');
    var variantIn=document.getElementById('variant-id'),atcBtn=document.querySelector('.product-atc__btn'),stockEl=document.getElementById('product-stock');
    if(priceEl)priceEl.textContent=fmtMoney(v.price);
    if(compareEl){
      if(v.compare_at_price>v.price){
        compareEl.textContent=fmtMoney(v.compare_at_price);compareEl.hidden=false;
        if(discountEl){discountEl.textContent='-'+Math.round((v.compare_at_price-v.price)/v.compare_at_price*100)+'%';discountEl.hidden=false;}
      }else{compareEl.hidden=true;if(discountEl)discountEl.hidden=true;}
    }
    if(variantIn)variantIn.value=v.id;
    if(atcBtn)atcBtn.disabled=!v.available;
    if(stockEl){
      stockEl.className='product-stock'+(v.available?' product-stock--in':' product-stock--out');
      stockEl.innerHTML=v.available
        ?'<span class="product-stock__dot"></span><span>En stock | Expédié en moins de <strong>48h</strong></span>'
        :'<span class="product-stock__dot"></span><span>Rupture de stock</span>';
    }
    if(v.featured_image){var sid=String(v.featured_image.id);var d=imageMapById[sid];Gallery.setVariantImage(sid,d?d.src:'',d?d.alt:'');}
    if(window.history)window.history.replaceState(null,'','?variant='+v.id);
    updateBundleCards();
    updateOptionAvailability();
  }

  /*
   * Si la taille selectionnee n'est pas dispo pour la nouvelle couleur,
   * on cherche la premiere taille disponible pour cette couleur et on l'active.
   */
  function resolveVariantAfterSwatchChange(){
    var v=findVariant(Object.values(selectedOptions));
    if(v){
      applyVariant(v);
      return;
    }
    /* Pas de variante valide : trouver la 1ere combinaison dispo */
    var fallback=null;
    /* Chercher parmi les options non-couleur (idx != position du swatch clique) */
    var optionGroups=Array.from(document.querySelectorAll('.product-option__values'));
    for(var g=0;g<optionGroups.length;g++){
      var optIdx=parseInt(optionGroups[g].dataset.optionIdx,10);
      if(isNaN(optIdx))continue;
      var btns=Array.from(optionGroups[g].querySelectorAll('.product-option__value:not(.unavailable)'));
      if(btns.length){
        /* Tester la premiere valeur disponible pour cet index */
        var candidate={};
        Object.keys(selectedOptions).forEach(function(k){candidate[k]=selectedOptions[k];});
        candidate[optIdx]=btns[0].dataset.value;
        fallback=findVariant(Object.values(candidate));
        if(fallback){
          /* Activer ce bouton visuellement */
          selectedOptions[optIdx]=btns[0].dataset.value;
          optionGroups[g].querySelectorAll('.product-option__value').forEach(function(b){b.classList.remove('active');});
          btns[0].classList.add('active');
          break;
        }
      }
    }
    if(fallback){applyVariant(fallback);}
    /* Meme si pas de fallback, mettre a jour les prix/ATC via la 1ere variante de la couleur */
    if(!fallback){
      /* Juste mettre a jour les boutons de dispo, le prix reste inchange */
      updateBundleCards();
      updateOptionAvailability();
    }
  }

  document.querySelectorAll('.swatch').forEach(function(sw){
    sw.addEventListener('click',function(){
      var pos=parseInt(this.dataset.optionPosition)-1;
      selectedOptions[pos]=this.dataset.swatchValue;
      this.closest('.product-swatches__list').querySelectorAll('.swatch').forEach(function(s){s.classList.remove('swatch--active');});
      this.classList.add('swatch--active');
      var n=document.getElementById('swatch-selected-name');if(n)n.textContent=this.dataset.swatchValue;
      /* 1. Mettre a jour la dispo des tailles IMMEDIATEMENT */
      updateOptionAvailability();
      /* 2. Resoudre la variante (avec fallback si taille actuelle indispo) */
      resolveVariantAfterSwatchChange();
    });
  });

  document.querySelectorAll('.product-option__value').forEach(function(btn){
    btn.addEventListener('click',function(){
      if(this.classList.contains('unavailable'))return;
      var idx=parseInt(this.dataset.optionIndex);
      selectedOptions[idx]=this.dataset.value;
      this.closest('.product-option__values').querySelectorAll('.product-option__value').forEach(function(b){b.classList.remove('active');});
      this.classList.add('active');
      applyVariant(findVariant(Object.values(selectedOptions)));
    });
  });

  document.querySelectorAll('.bundle-card').forEach(function(card){
    card.addEventListener('click',function(){
      if(this.classList.contains('bundle-card--unavailable')||this.getAttribute('aria-disabled')==='true')return;
      var idx=parseInt(this.dataset.optionIndex,10);
      selectedOptions[idx]=this.dataset.value;
      applyVariant(findVariant(Object.values(selectedOptions)));
    });
  });

  updateBundleCards();
  updateOptionAvailability();

  var qtyInput=document.getElementById('product-qty');
  document.querySelectorAll('.qty-selector__btn').forEach(function(btn){
    btn.addEventListener('click',function(){
      if(!qtyInput)return;
      qtyInput.value=Math.max(1,(parseInt(qtyInput.value)||1)+(parseInt(this.dataset.delta)||0));
    });
  });

  var cdEl=document.getElementById('countdown-timer');
  if(cdEl){
    var cutoffH=parseInt(cdEl.dataset.cutoff||'18'),sMin=parseInt(cdEl.dataset.shipMin||'1'),sMax=parseInt(cdEl.dataset.shipMax||'2'),dMin=parseInt(cdEl.dataset.delMin||'5'),dMax=parseInt(cdEl.dataset.delMax||'8'),today=new Date();
    var tlShip=document.getElementById('tl-ship-date'),tlDel=document.getElementById('tl-del-date');
    if(tlShip)tlShip.textContent=frDate(addDays(today,sMin))+(sMin!==sMax?' – '+frDate(addDays(today,sMax)):'');
    if(tlDel)tlDel.textContent=frDate(addDays(today,sMax+dMin))+' – '+frDate(addDays(today,sMax+dMax));
    function tick(){var now=new Date(),c=new Date();c.setHours(cutoffH,0,0,0);if(now>=c)c.setDate(c.getDate()+1);var d=c-now;cdEl.textContent=pad(Math.floor(d/3600000))+'h '+pad(Math.floor(d%3600000/60000))+'min '+pad(Math.floor(d%60000/1000))+'s';}
    tick();setInterval(tick,1000);
  }

  /* Note : le toggle des questions FAQ (.faq-item__question) est desormais
     gere directement dans sections/product-faq-nested.liquid, pour que
     l'accordeon fonctionne aussi sur les collections/la home/les pages,
     pas seulement sur les fiches produit ou ce fichier product.js est charge. */
  document.querySelectorAll('.product-accordion__trigger').forEach(function(btn){
    btn.addEventListener('click',function(){var panel=this.nextElementSibling,open=this.getAttribute('aria-expanded')==='true';this.setAttribute('aria-expanded',String(!open));if(panel)panel.hidden=open;});
  });

  var modal=document.getElementById('size-guide-modal');
  function openM(){if(modal){modal.hidden=false;document.body.style.overflow='hidden';}}
  function closeM(){if(modal){modal.hidden=true;document.body.style.overflow='';}}
  var ob=document.getElementById('size-guide-open'),cb=document.getElementById('size-guide-close'),ov=modal&&modal.querySelector('.size-guide-modal__overlay');
  if(ob)ob.addEventListener('click',openM);
  if(cb)cb.addEventListener('click',closeM);
  if(ov)ov.addEventListener('click',closeM);
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&modal&&!modal.hidden)closeM();});
});
